import { Injectable } from '@angular/core';
import { ConfirmationResult } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class PhoneAuthStateService {
  private confirmationResult: ConfirmationResult | null = null;
  private phoneNumber: string = '';
  private sessionId: string | null = null;

  setConfirmationResult(confirmationResult: ConfirmationResult | null, phoneNumber: string, sessionId?: string): void {
    this.confirmationResult = confirmationResult;
    this.phoneNumber = phoneNumber;
    this.sessionId = sessionId || null;
  }

  getConfirmationResult(): ConfirmationResult | null {
    return this.confirmationResult;
  }

  getPhoneNumber(): string {
    return this.phoneNumber;
  }

  getSessionId(): string | null {
    return this.sessionId;
  }

  clear(): void {
    this.confirmationResult = null;
    this.phoneNumber = '';
    this.sessionId = null;
  }
}
